import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

interface ProtectedRouteProps {
  checkAccess: () => boolean;
  fallbackPath: string;
  children: ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  checkAccess,
  fallbackPath,
  children,
}) => {
  return checkAccess() ? <>{children}</> : <Navigate to={fallbackPath} />;
};

export default ProtectedRoute;
